import { IconBase, type IconProps } from './IconBase';

/**
 * CorazonIcon — corazon de contorno simple.
 *
 * Simbolo: favoritos, afecto, cuidado.
 *
 * Composicion:
 * - Un solo path con dos arcos circulares en la parte superior
 *   (lobulos izquierdo y derecho) que convergen en V hacia el punto
 *   inferior. Construido con curvas cubic Bezier para asegurar simetria
 *   y suavidad sin sobrecargar detalles.
 * - Sin relleno: contorno limpio para uso como toggle (filled/outline).
 */
export function CorazonIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      {/* Contorno completo del corazon */}
      <path d="M12 20.5 C 8 17.5 3.5 14 3.5 9.5 A 4.5 4.5 0 0 1 12 7 A 4.5 4.5 0 0 1 20.5 9.5 C 20.5 14 16 17.5 12 20.5 Z" />
    </IconBase>
  );
}
